import { render } from "@testing-library/react";
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../Navbar/Navbar";
import "./Header.css";
import Jail_LOGO from "../../../assets/images/jailtele-logo.png";
import Jail_LOGO1 from "../../../assets/images/Jail-TeleHealthLogo.png";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  return (
    <div>
      <section className="header fixed top-0 left-0 w-full z-10 bg-white">
        <section className="header-top" style={{ position: 'relative', minHeight: 80 }}>
          {/* Logo */}
          <section className="header-top__logo hidden md:flex">
            <span
              className="header-logo"
              onClick={() => {
                //navigate("/facility-dashboard");
              }}
            >
              <img className="logo" src={Jail_LOGO1} style={{ height: "80px" }} />
            </span>
          </section>

          {/* Absolutely centered urgent message */}
          <div style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2,
            pointerEvents: 'none',
            width: 'auto',
            maxWidth: '90vw',
            minWidth: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: 16,
            paddingRight: 16,
          }}>
            <span style={{ fontWeight: 'bold', color: 'grey', fontSize: '1.1rem', padding: '0.25rem 1.5rem', wordBreak: 'break-word', textAlign: 'center', whiteSpace: 'normal' }}>
              For Urgent or After Hours, Call (855) 270-3625, Option 2: Corrections
            </span>
          </div>

          {/* Navbar */}
          <section className="header-top__navbar">{<Navbar />}</section>
        </section>
      </section>
    </div>
  );
}

export default Header;
